// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-messagecard.bolt-card {
  padding: 0;
}
.bolt-messagecard .bolt-messagebar {
  padding: 0;
}
.bolt-messagecard .bolt-messagebar.severity-info {
  background-color: rgba( 255, 255, 255 ,  1 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
}
.bolt-messagecard .bolt-messagebar-content {
  padding: 16px 20px 16px 12px;
  border-radius: 4px;
}

/*# sourceMappingURL=MessageCard.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/MessageCard/MessageCard.scss","webpack://./../azure-devops-ui/bin/Components/MessageCard/MessageCard.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAEI;EACI,UAAA;ACDR;ADGI;EACI,UAAA;ACDR;ADGQ;EACI,4CEwFJ;EDzFN,qEAAqE;ADInE;ACFJ;EDIQ,4BAAA;ECFN,kBAAkB;AACpB;;AAEA,0CAA0C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
